import { useEffect, useRef, useState } from 'react';
import { Slider } from '@/components/ui/slider';
import { toast } from 'sonner';
import { updateMeetingMicrophoneVolume } from '../api/api-setting-meeting';

interface Props {
  meetingId: string;
  imei: string;
  name: string;
  volume: number;
  disabled?: boolean;
  onSaved: () => Promise<void>;
}

export function MeetingMicrophoneVolume({meetingId, imei, name, volume, disabled, onSaved}: Props) {
  const [value, setValue] = useState(volume);
  const [saving, setSaving] = useState(false);
  const savingRef = useRef(false);
  const confirmedValue = useRef(volume);
  useEffect(() => {
    confirmedValue.current = volume;
    if (!savingRef.current) setValue(volume);
  }, [meetingId, imei, volume]);

  const save = async ([next]: number[]) => {
    if (disabled || savingRef.current) return;
    savingRef.current = true;
    setSaving(true);
    try {
      await updateMeetingMicrophoneVolume(meetingId, imei, next);
      confirmedValue.current = next;
      setValue(next);
      toast.success(`Đã gửi âm lượng MIC ${name}: ${next}%`);
      // A refresh failure must not undo a successfully sent command.
      await onSaved().catch(() => {});
    } catch {
      setValue(confirmedValue.current);
      toast.error('Không gửi được âm lượng MIC. Vui lòng thử lại.');
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  return <div className="flex min-w-32 items-center gap-2" title="0%: không thu tiếng · 100%: mức thu gốc">
    <Slider aria-label={`Âm lượng MIC ${name}`} min={0} max={100} step={1}
      value={[value]} disabled={disabled || saving} className="flex-1"
      onValueChange={([next]) => setValue(next)} onValueCommit={save}/>
    <span className="min-w-9 text-right text-xs tabular-nums" aria-live="polite">{value}%</span>
  </div>;
}
